<script>
import BarList from '../components/bar-list'
import CtaForm from './cta-form'
import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codcta: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        ctaList: function () {
            // console.log(this.$store.getters.getCtaList)
            return this.$store.getters.getCtaList
        },

        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        usuario: function () {
            return this.$store.getters.getEnv.uuid
        },
    },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },
    },

    methods: {
        getTipocta (value) {
           return getText(value, this.metadata.cta.tipocta)
        },

        getBoleto (value) {
           return getText(value, this.metadata.cta.emiteboleto)
        },

        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codcta = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codcta = ''
            this.showForm = true;
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcta":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        async loadData() {
            this.$store.dispatch('loadCta', { filter: this.filter, page: this.nextPage } )
        },

        data (value) {
            return formatDate(value)
        },        

    },

    components: {
        BarList, CtaForm,
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Conta" 
                plural-entity="Contas"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="ctaList.length == 0" type="warning" text="Nenhuma conta foi encontrada"></alert>
                <div class="mainbox" v-for="(cta, index) in ctaList" v-bind:key="index">
                    <div class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <!-- <label class="lbl-list"> {{metadata.cta.descricao.label}} </label> -->
                                <span class="lbl-title-produto">{{ cta.descricao }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.cta.codcta.label}} </label><br>
                                <span class="data-list">{{ cta.codcta }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.cta.tipocta.label}} </label><br>
                                <span class="data-list">{{ getTipocta(cta.tipocta) }}</span>
                            </div>
                            <div class="col-md-2 col-3" v-if="cta.banco">
                                <label class="lbl-list"> {{metadata.cta.banco.label}} </label><br>
                                <span class="data-list">{{ cta.banco_nome }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.cta.emiteboleto.label}} </label><br>
                                <span class="data-list">{{ getBoleto(cta.emiteboleto) }}</span>
                            </div>
                            <div class="col-md-2 col-6 ml-auto">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(cta.codcta)" 
                                    v-on:view="handleEdit(cta.codcta, true)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <transition name="fade">
            <cta-form v-if="showForm" :index="this.codcta" :crud="this.crud" v-on:closeform="closeForm"></cta-form>
        </transition>


    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/cta-list.vue